export default function createBillingsStoreRequest(formData) {
  return {
    date: formData.date,
    amount: formData.spent,
    fee: formData.fee,
    bonus: formData.bonus,
    payment_method_commission: formData.paymentMethodCommission,
  };
}
